// CTA / Scarcity Section - Emphasize limited beta access with high-contrast CTA
import DownloadEmailForm from "./DownloadEmailForm"
import { Users } from "lucide-react"

const CallToAction = () => {
  return (
    <section className="bg-gradient-to-br from-blue-600 to-blue-700 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        {/* Scarcity Badge */}
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium mb-6">
          <Users className="w-4 h-4" />
          <span>Limited Beta Access</span>
        </div>

        {/* Headline */}
        <h2 className="text-4xl sm:text-5xl lg:text-5xl font-semibold text-white mb-6 leading-tight">
          Join 100 Beta Testers
        </h2>
        
        {/* Subheadline */}
        <p className="text-xl sm:text-2xl text-blue-50 mb-8 max-w-2xl mx-auto leading-relaxed">
          Get early access to Sentivo and help shape the future of Mac search. 
          Limited spots available.
        </p>

        {/* CTA Form */}
        <div className="mb-8">
          <DownloadEmailForm
            downloadUrl="https://pub-6f7c3d3ca81344b2ac370e1a84d731b4.r2.dev/Sentivo.dmg"
            buttonLabel="Download"
            className="max-w-xl mx-auto text-white"
            placeholderWhite={true}
          />
        </div>

        {/* Scarcity Message */}
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 max-w-2xl mx-auto">
          <p className="text-white font-semibold mb-2">
            Limited beta spots available
          </p>
          <p className="text-blue-50 text-sm">
            We're accepting a small group of early testers to ensure quality feedback and support. 
          </p>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap items-center justify-center gap-6 mt-8 text-blue-100 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-400 rounded-full"></div>
            <span>No credit card required</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-400 rounded-full"></div>
            <span>Free during beta</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-400 rounded-full"></div>
            <span>Privacy-first</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
